import EntitiesBodyWrapper from 'components/Entities/EntitiesBodyWrapper';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { FILTER_KEYS, SCOPE } from '../../config/constants';

import EntitiesBody from './EditEntities';
import { useRouter } from '../../helpers/customHooks';
import { useFiltersState } from '../../store/hooks';
import { useDataOpsDispatch } from '../../store/hooks/dataOps';
import { history } from '../../store/reducers';
import DataOpsTimeSlider from './DataOpsTimeSlider';
import { PracticeDataOps, Times } from './types';
import * as DateFns from 'date-fns';

type ModalEditEntitiesProps = {
  show:boolean;
  practice: PracticeDataOps;
  onModalClose: ()=>void;
}

const ModalEditEntities = ({ show, practice, onModalClose }: ModalEditEntitiesProps) => {
  const dates = { first: new Date(practice.start_time), second: new Date(practice.end_time) } as {first: Date | number;second: Date | number};
  const {specificScope} = useRouter();
  const { saveTargetedRetrack } = useDataOpsDispatch();
  const { [FILTER_KEYS.TARGETED_RETRACK]: isTargetedRetrack=false } = useFiltersState(specificScope, FILTER_KEYS.TARGETED_RETRACK);
  const onHideOverride = () => {
    onModalClose();
    history.push(SCOPE.DATAOPS.ROUTES.PAGE());
  };

  const onSaveClick = () => {
    saveTargetedRetrack(practice, dates.first, dates.second);
    onHideOverride();
  };
  const isToday = DateFns.isToday(new Date(practice.start_time)); 
  const teamId = practice.home_team_id;
  return (
    <Modal
      show={show}
      onHide={() => onHideOverride()}
      dialogClassName="modal-edit-entities"
      aria-labelledby="example-custom-modal-styling-title"
      size="xl"
    >
      <Modal.Body>
        {/* @ts-ignore */} 
       { isToday ?  <EntitiesBodyWrapper isToday={isToday} teamId={teamId} /> : <EntitiesBody practice={practice} /> } 
        {isTargetedRetrack &&<DataOpsTimeSlider
          times={{ first: new Date(practice.start_time), second: new Date(practice.end_time) }}
          changeTimes={(times:{first: number | Date; second: number | Date}) => {
            dates.first = times.first;
            dates.second = times.second;
          }}
        />}
        <div className="entities-modal-btns">
          <button className="btn-transparet" onClick={() => onHideOverride()}>CANCEL</button>
          <button
            className="btn-blue"
            onClick={() => onSaveClick()}
          >
            SAVE
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default React.memo(ModalEditEntities);
